<template>
  <v-dialog v-model="show" max-width="500px" :retain-focus="false">
    <v-card class="signature-card">
      <v-card-title class="primary">
        <span class="headline white--text text-uppercase">Signature Pad</span>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div id="signaturePad">
        <VueSignaturePad
          width="95%"
          height="200px"
          ref="signaturePad"
          :options="{
            onBegin: () => {
              $refs.signaturePad.resizeCanvas();
            },
          }"
        />
      </div>
      <v-divider></v-divider>
      <v-card-actions class="mr-12">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1 white--text" @click="save">
          <div class="text-caption text-sm-body-1">
            Save
          </div>
        </v-btn>
        <v-btn @click="undo">
          <div class="text-caption text-sm-body-1">
            undo
          </div></v-btn
        >
        <v-btn @click="clear">
          <div class="text-caption text-sm-body-1">
            clear
          </div></v-btn
        >
        <v-btn color="red darken-1 white--text" @click.stop="show = false">
          <div class="text-caption text-sm-body-1">
            cancel
          </div></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    showSignaturePad: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    show: {
      get() {
        return this.showSignaturePad;
      },
      set(val) {
        if (!val) {
          this.$refs.signaturePad.clearSignature();
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.$emit("signatureData", data);
      this.show = isEmpty;
    },

    undo() {
      this.$refs.signaturePad.undoSignature();
    },

    clear() {
      this.$refs.signaturePad.clearSignature();
    },
  },
};
</script>

<style scoped>
.signature-card {
  width: 700px;
}
#signaturePad {
  cursor: crosshair;
}

.signature-card .v-card__actions >>> button {
  flex: 1 0 auto !important;
}

>>> canvas {
  display: block;
  margin: auto;
}
#signaturePad > div {
  box-shadow: rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px,
    rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px,
    rgb(0 0 0 / 9%) 0px -3px 5px;
  margin: 15px auto;
  border-radius: 5px;
  border: none;
}
@media only screen and (max-width: 768px) {
  .signature-card {
    width: 100%;
  }
}
</style>
